import { Form, FormInstance, Input } from "antd";
import { capitalize } from "../../../../../utils/string";
import { validateEmail, validateMobile } from "../../../../../utils/validators";

interface ContactFormProps {
  form: FormInstance<any>;
}

const Contacts = ({ form }: ContactFormProps) => {
  const initialContents = [
    { contact_type: "operational" },
    { contact_type: "technical" },
    { contact_type: "billing" },
  ];

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{ contacts: initialContents }}
      size="large"
      requiredMark={false}
      className="custom-form"
    >
      {initialContents.map((contact, index) => (
        <div
          key={index}
          className="space-y-6 p-5 rounded-xl border border-theme-indigo-50 mb-5"
        >
          <h5 className="text-lg text-theme-gray-2 font-semibold">
            {capitalize(contact.contact_type)}{" "}
            {contact.contact_type === "operational" && "*"}
          </h5>

          <div className="grid grid-cols-2 gap-x-4">
            <Form.Item
              name={["contacts", index, "contact_type"]}
              className="!hidden"
            >
              <Input placeholder="Enter person name" />
            </Form.Item>
            <Form.Item
              label="Contact Person"
              name={["contacts", index, "name"]}
              rules={[
                {
                  required: contact.contact_type === "operational",
                  message: "Contact person is required",
                },
              ]}
            >
              <Input placeholder="Enter person name" />
            </Form.Item>

            <Form.Item
              label="Contact Number"
              name={["contacts", index, "contact_number"]}
              rules={[
                {
                  required: contact.contact_type === "operational",
                  message: "Please enter contact number",
                },
                { validator: validateMobile },
                {
                  validator: (_rule, value) => {
                    if (!value) return Promise.resolve();
                    const contacts = form.getFieldValue("contacts") || [];
                    const duplicates = contacts.filter(
                      (c: any, i: number) =>
                        c.contact_number === value && i !== index,
                    );
                    if (duplicates.length > 0) {
                      return Promise.reject(
                        new Error("Contact number already exist"),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input prefix="+880" placeholder="1712345678" />
            </Form.Item>

            <Form.Item
              label="Email Address"
              name={["contacts", index, "email"]}
              rules={[
                {
                  required: contact.contact_type === "operational",
                  message: "Please enter email address",
                },
                { validator: validateEmail },
                {
                  validator: (_rule, value) => {
                    if (!value) return Promise.resolve();
                    const contacts = form.getFieldValue("contacts") || [];
                    const duplicates = contacts.filter(
                      (c: any, i: number) => c.email === value && i !== index,
                    );
                    if (duplicates.length > 0) {
                      return Promise.reject(new Error("Email already exist"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>

            <Form.Item
              label="Designation"
              name={["contacts", index, "designation"]}
              rules={[
                {
                  required: contact.contact_type === "operational",
                  message: "Please enter designation",
                },
              ]}
            >
              <Input placeholder="Enter designation" />
            </Form.Item>
          </div>
        </div>
      ))}
    </Form>
  );
};

export default Contacts;
